// @flow

import React, { Fragment } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'
import Colors from 'components/styles/colors'

const Desc = styled.pre`
  margin-top: ${spacing.small_3}px;
  color: ${Colors.black};
  font-size: ${fontSize.small_3}px;
  text-align: center;
  line-height: 1.454;
  white-space: pre-wrap;
`
const Title = styled.p`
  font-size: ${fontSize.small_3}px;
  font-weight: bold;
  text-align: center;
`

type PropTypes = {
  telNumber: string,
}

export default function ReservationAddress(props: PropTypes) {
  return (
    <Fragment>
      <Title>{i18n.t('page.dashboard.inbox.contactAddress')}</Title>
      <Desc>
        {i18n.t('page.dashboard.inbox.tel')}
        <a href={`tel:${props.telNumber}`}>{props.telNumber}</a>
      </Desc>
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/ReservationAddress/index.jsx